var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){_vm.signInWithGoogle()}}},[_vm._v("Sign In with Google")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }